// extracted by mini-css-extract-plugin
export default {"icon":"Icon-module__icon___BjyRT"};